export default __webpack_public_path__ + "static/media/photo--lg--wheel-10.897f5ed1.jpg";